import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import constants from '../../../_consts';

Vue.use(VueAxios, axios);

const getters = {
  GETTERS_CLIENT_BY_ID: state => id => state.clientsList.find(client => (client.id === id)),
  GETTERS_CLIENT_LIST: state => state.clientsList,
  GETTERS_RECENT_CLIENT_LIST: state => state.recentClientsList.slice(0, 4),
  GETTERS_CLIENT_LIST_ID: (state) => {
    let ids = [];
    state.clientsList.forEach(client => {
      ids.push(client.id);
    });
    return ids;
  },
  GETTERS_CLIENT_LIST_KEYWORD: state => state.clientsList.filter(client => ((client.clientName && client.clientName.toLowerCase().indexOf(state.keywordSearchClient.toLowerCase()) >= 0) || (client.eventManagerName && client.eventManagerName.toLowerCase().indexOf(state.keywordSearchClient.toLowerCase()) >= 0) || (client.managerName && client.managerName.toLowerCase().indexOf(state.keywordSearchClient.toLowerCase()) >= 0))),
  GETTERS_KEYWORD_SEARCH_CLIENT: state => state.keywordSearchClient,
  GETTERS_IS_ERROR: state => state.isError,
  GETTERS_ERROR_MESSAGE: state => state.errorMessage,
  GETTERS_GET_CLIENT_NAME: state => state.clientName || localStorage.getItem(constants.LOCAL_STORE.clientName),
  GETTERS_GET_VALID_TOKEN: state => state.isValidToken || false,
  GETTERS_GET_LOGIN_EMAIL: state => state.loginEmail || '',
  GETTERS_IS_RESET_PASSWORD_SUCCESS: state => state.isResetPasswordSuccess,
  GETTERS_IS_SUBMITTED: state => state.isSubmitted,
  GETTERS_SHOW_CAPTCHA: state => state.showCaptcha,
  GETTERS_SITE_KEY: state => state.siteKey,
  GETTERS_GET_LIST_AM: state => state.listAM,
  GETTERS_GOOGLE_API_KEY: state => state.googleAPIKey,
  GETTERS_TOKEN_RESET_PASSWORD: state => state.resetPassToken,
  GETTERS_ALLOW_LOGIN: state => state.allowLogin,
  GETTER_GET_SUBMISSION_MESSAGE: state => state.submissionMessage,
  GETTER_GET_CHANGE_ORDER_MESSAGE: state => state.changeOrderMessage,
  GETTER_GET_EMAIL_NOTIFICATION: state => state.isCheckedNotification,
  GETTER_GET_SELECTED_CLIENT: state => state.selectedClient,
  // GETTER_GET_USER_LIST: (state) => clientId => {
  //   return (clientId === null || clientId === undefined) ? state.userList : state.userList.find(user => user.client.id === clientId);
  // }
  GETTER_GET_USER_LIST: (state) => role => {
    return role === constants.USER_ROLE.eventManager ? state.userList.filter(user => user.role !== constants.USER_ROLE.admin) : state.userList;
  },
  GETTER_GET_MANAGER_VIEW: state => state.managerView,
  GETTER_GET_USER_LIST_FOR_EM: state => state.userList.filter(user => user.role !== constants.USER_ROLE.admin),
  GETTER_GET_IS_LOADING: state => state.isLoading,
  GETTER_GET_VALIDATOR_LIST: state => state.validators,
  GETTERS_IS_LOADING_STAFFING: state => state.isLoadingStaffing
};

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/clients/getters.js